import { useEffect, useState } from 'react';
import CitizenStatCard from './CitizenStatCard';
import { getCitizenPriceCount } from '../getData';

type CitizenBasicStatisticsProps = {
  t: (key: string) => string;
};

const CitizenBasicStatistics = ({ t }: CitizenBasicStatisticsProps) => {
  const [recentCitizenReportCountData, setRecentCitizenReportCountData] = useState<{
    lastWeekCount: number;
    lastMonthCount: number;
    lastYearCount: number;
    totalCount: number;
  }>({
    lastWeekCount: 0,
    lastMonthCount: 0,
    lastYearCount: 0,
    totalCount: 0,
  });

  useEffect(() => {
    getCitizenPriceCountData();
  }, []);

  const getCitizenPriceCountData = async () => {
    const { lastWeekCount, lastMonthCount, lastYearCount, totalCount } = await getCitizenPriceCount();

    setRecentCitizenReportCountData({
      lastWeekCount,
      lastMonthCount,
      lastYearCount,
      totalCount,
    });
  };

  return (
    <section className="mb-12 w-full space-y-8 rounded-lg border-[1px] border-card-border-color bg-card-bg-color p-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
        <CitizenStatCard title={t('lastWeek')} value={recentCitizenReportCountData.lastWeekCount || 0} />
        <CitizenStatCard title={t('month')} value={recentCitizenReportCountData.lastMonthCount || 0} />
        <CitizenStatCard title={t('year')} value={recentCitizenReportCountData.lastYearCount || 0} />
        <CitizenStatCard title={t('total')} value={recentCitizenReportCountData.totalCount || 0} />
      </div>
    </section>
  );
};

export default CitizenBasicStatistics;
